export default [
  {
    path: '/addCard',
    name: 'AddCard',
    component: () => import('@/views/bindCard/addCard.vue'),
  },
  {
    path: '/validCardInfo',
    name: 'ValidCardInfo',
    component: () => import('@/views/bindCard/validCardInfo.vue'),
  },
  {
    path: '/3ds',
    name: '3DS',
    component: () => import('@/views/bindCard/3DS.vue'),
  },
  {
    path: '/bindUnionCard',
    name: 'BindUnionCard',
    component: () => import('@/views/bindCard/bindUnionCard.vue'),
  },
  {
    path: '/bindUnionCardComplete',
    name: 'BindUnionCardComplete',
    component: () => import('@/views/bindCard/bindUnionCardComplete.vue'),
  },
]
